import { render, staticRenderFns } from "./form_textarea.vue?vue&type=template&id=70e9bca3&scoped=true&lang=pug"
import script from "./form_textarea.vue?vue&type=script&lang=js"
export * from "./form_textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9bca3",
  null
  
)

export default component.exports